import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { push } from 'react-router-redux'
import { getCurrentYear } from '../../utils/time'
import H5 from '../typography/headers/H5'

export default class AuthenticatedFooter extends PureComponent {
  constructor(props) {
    super(props)
    this.onPoliciesClickBound = this.onPoliciesClick.bind(this)
  }

  render() {
    return (
      <div className="container">
        <div
          className="logo"
          onClick={() => window.open('https://www.opportunityeducation.org/')}
        />
        <div className="copyright-policies-container">
          <div className="caption1">
            <div>
              {`© 2012-${getCurrentYear()} Opportunity Education Foundation, Inc.`}
            </div>
            <div style={{ display: 'flex' }}>
              Quest Forward Learning™ | All rights reserved. |
              <div className="ourpolicies" onClick={this.onPoliciesClickBound}>
                &nbsp;&nbsp;Our Policies
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  onPoliciesClick() {
    this.props.dispatch(push('/ourpolicies'))
  }
}

AuthenticatedFooter.propTypes = {
  dispatch: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/footers/AuthenticatedFooter.js